// Utility functions for managing permission preferences

import { getOrCreateDeviceId } from '../services/DeviceService';

/**
 * Clear permission skip preference to allow permission dialogs to show again
 */
export const resetPermissionPreferences = async () => {
  try {
    const deviceId = await getOrCreateDeviceId();
    const { Preferences } = await import('@capacitor/preferences');
    await Preferences.remove({ key: `preferences:permissions/${deviceId}` });
    console.log('✅ Permission preferences reset - dialogs will show again');
    return { success: true };
  } catch (error) {
    console.error('❌ Failed to reset permission preferences:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Check if user has skipped permissions forever
 */
export const hasSkippedPermissionsForever = async () => {
  try {
    const deviceId = await getOrCreateDeviceId();
    const { Preferences } = await import('@capacitor/preferences');
    const { value } = await Preferences.get({ key: `preferences:permissions/${deviceId}` });
    
    if (!value) return false;
    
    const permissionData = JSON.parse(value);
    return permissionData.skipped === true;
  } catch (error) {
    console.error('❌ Failed to check permission skip status:', error);
    return false;
  }
};

/**
 * Save permission skip preference
 */
export const savePermissionSkipPreference = async () => {
  try {
    const deviceId = await getOrCreateDeviceId();
    const { Preferences } = await import('@capacitor/preferences');
    await Preferences.set({ 
      key: `preferences:permissions/${deviceId}`, 
      value: JSON.stringify({ skipped: true, timestamp: Date.now() }) 
    });
    console.log('💾 Permission skip preference saved');
    return { success: true };
  } catch (error) {
    console.error('❌ Failed to save permission skip preference:', error);
    return { success: false, error: error.message };
  }
};
